import { TokenResult } from './location-token.model';

//todo: should be extracted, same token is also in authentication
export class LocationResponse {
  public name: string;
  public transactionID: number;
  public token: TokenResult;
}
